export enum StorageConst {
  TOKEN = 'TOKEN',
  USER = 'USER',
  X = 'x',
  Y = 'y',
  ACCESS_CODE = 'ACCESS_CODE',
  REDIRECTED_FROM_POS = 'REDIRECTED_FROM_POS',
  REDIRECTED_FROM_MULTI_VERSION = 'REDIRECTED_FROM_MULTI_VERSION',
  RETURN_URL = 'returnUrl',
  DEFAULT_MENU_ITEM_REDIRECTED = 'defaultMenuItemRedirected',
}
